import {create} from "zustand";
import {IUserIPRestrictionEntity} from '../components/DealerAdmin/IPRestrictionInterface';

export interface IUserIPRestrictionStore {
    ipRestriction:IUserIPRestrictionEntity[];
    setIpRestriction:(ipRestriction:IUserIPRestrictionEntity[]) => void;
}

export const useUserIPRestrictionStore = create<IUserIPRestrictionStore>((set) => ({
    ipRestriction:[],
    setIpRestriction: (ipRestriction) => set(() => ({ ipRestriction })),
 }));
